import React, { useEffect, useRef } from 'react';

function GetEvenDonut({ d3, data }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!d3 || !containerRef.current || !data) return;

    const { success, fail } = data;
    const donutData = [
      { label: 'Success', value: success },
      { label: 'Fail', value: fail },
    ];

    const container = containerRef.current;
    container.innerHTML = '';

    const width = 400;
    const height = 400;
    const margin = 10;
    const radius = Math.min(width, height) / 2 - margin;

    const svg = d3
      .select(container)
      .append('svg')
      .attr('viewBox', `0 0 ${width} ${height}`)
      .style('width', '100%')
      .style('height', 'auto')
      .append('g')
      .attr('transform', `translate(${width / 2}, ${height / 2})`);

    const color = d3
      .scaleOrdinal()
      .domain(donutData.map((d) => d.label))
      .range(['#96e6ab', '#df87a8']);

    const pie = d3.pie().value((d) => d.value).padAngle(0.02);
    const arcData = pie(donutData);

    const total = d3.sum(donutData, (d) => d.value) || 1;
    const smallAngleThreshold = 0.35; // ~20 degrees
    const largeSlices = arcData.filter((d) => d.endAngle - d.startAngle >= smallAngleThreshold);
    const smallSlices = arcData.filter((d) => d.endAngle - d.startAngle < smallAngleThreshold);

    const arc = d3.arc().innerRadius(60).outerRadius(radius);

    svg
      .selectAll('path')
      .data(arcData)
      .join('path')
      .attr('d', arc)
      .attr('fill', (d) => color(d.data.label))
      .attr('stroke', 'white')
      .style('stroke-width', '2px');

    const labelArc = d3.arc().innerRadius(radius * 0.5).outerRadius(radius * 0.8);

    // Labels for large slices only
    svg
      .selectAll('text.ge-label')
      .data(largeSlices)
      .join('text')
      .attr('class', 'ge-label')
      .attr('transform', (d) => `translate(${labelArc.centroid(d)})`)
      .style('text-anchor', 'middle')
      .style('font-size', '16px')
      .style('fill', '#444')
      .text((d) => `${d.data.label} (${((d.data.value / total) * 100).toFixed(1)}%)`);

    // Legend for small slices
    const existingLegend = container.querySelector('.ge-legend');
    if (existingLegend) existingLegend.remove();

    const legend = document.createElement('div');
    legend.className = 'ge-legend';
    Object.assign(legend.style, {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gap: '8px 16px',
      marginTop: '12px',
      alignItems: 'center',
      alignContent: 'start',
      fontSize: '16px',
      color: '#444',
    });

    smallSlices.forEach((d) => {
      const row = document.createElement('div');
      row.style.display = 'flex';
      row.style.alignItems = 'center';
      row.style.gap = '8px';

      const swatch = document.createElement('span');
      swatch.style.display = 'inline-block';
      swatch.style.width = '12px';
      swatch.style.height = '12px';
      swatch.style.borderRadius = '2px';
      swatch.style.background = color(d.data.label);

      const text = document.createElement('span');
      const pct = ((d.data.value / total) * 100).toFixed(1);
      text.textContent = `${d.data.label} (${pct}%)`;

      row.appendChild(swatch);
      row.appendChild(text);
      legend.appendChild(row);
    });

    container.appendChild(legend);
  }, [d3, data]);

  return (
    <div className="chart-card svgfix">
      <h2>GET EVEN OR GET EVEN BETTER/WORSE SUCCESS</h2>
      <div ref={containerRef} />
    </div>
  );
}

export default GetEvenDonut;
